import { builder } from '@builder.io/react'
import '@builder.io/widgets/dist/lib/builder-widgets-async'

const BUILDER_API_KEY = process.env.BUILDER_API_KEY;
export const builderClient = builder.init(BUILDER_API_KEY);
builderClient.apiVersion = "v3";
